import { CircularProgressbar } from 'react-circular-progressbar';

import { ProgressCircleProps } from './ProgressCircle.interface';
import { IconLock } from '../Icons';
import { getValidClassNames } from '@/utils';

const ProgressCircle = ({ isLocked, percentageCompleted, styles }: ProgressCircleProps) => {
  return (
    <div className='relative'>
      {isLocked && (
        <div className={getValidClassNames({
          'absolute left-1/2 top-1/2 -translate-1/2': true,
          'bg-black color-white': percentageCompleted === 100,
          'bg-white': percentageCompleted !== 100
        })}>
          <IconLock />
        </div>
      )}
      <CircularProgressbar
        styles={{
          root: {
            backgroundColor: percentageCompleted === 100 ? 'var(--black)' : 'var(--white)',
            borderRadius: '50%',
            overflow: 'visible',
            maxHeight: '4rem',
            maxWidth: '4rem',
            width: '100%',
            ...styles?.root
          },
          path: {
            stroke: percentageCompleted === 100 ? 'var(--black)' : 'var(--yellow-400)',
            strokeWidth: 15,
            ...styles?.path
          },
          trail: {
            stroke: '#CCD8D9',
            strokeWidth: 14,
            ...styles?.trail
          },
          text: {
            fill: percentageCompleted === 100 ? 'var(--white)' : '#1B1B46',
            fontFamily: 'var(--font-heading)',
            fontSize: '1.5rem',
            fontWeight: '600',
            ...styles?.text
          },
        }}
        text={`${percentageCompleted && !isLocked ? percentageCompleted : 0}%`}
        value={Number(percentageCompleted)}
      />
    </div>
  );
};

export { ProgressCircle };
